import { render } from "./UpdateResults.vue?vue&type=template&id=248ea836&scoped=true"
import script from "./UpdateResults.vue?vue&type=script&lang=js"
export * from "./UpdateResults.vue?vue&type=script&lang=js"

import "./UpdateResults.vue?vue&type=style&index=0&id=248ea836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248ea836"]])

export default __exports__